import { render, staticRenderFns } from "./AddVendorManualFlow.vue?vue&type=template&id=59bf658c&scoped=true&"
import script from "./AddVendorManualFlow.vue?vue&type=script&lang=js&"
export * from "./AddVendorManualFlow.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorManualFlow.vue?vue&type=style&index=0&id=59bf658c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf658c",
  null
  
)

export default component.exports